import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SignaturePadComponent } from 'src/app/shared/components/signature-pad/signature-pad.component';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private httpClient: HttpClient) {
  }

  getSignatureDataUrl(signaturePad: SignaturePadComponent): string {
    
    const fullDataUrl = signaturePad.toDataUrl();
    const base64String = fullDataUrl.replace(/^data:image\/(png|jpeg|webp);base64,/, '');
    console.log(`Prefixo 'data:image/...;base64,' removido. String base64 pura (primeiros 10 chars): '${base64String.substring(0, 10)}...'`);
    return base64String;
  }

}